import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgAuthyIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: "50.168613mm",
	height: "67.813148mm",
	viewBox: "0 0 50.168613 67.813148",
	id: "svg1",
	xmlSpace: "preserve",
	"inkscape:version": "1.4 (e7c3feb100, 2024-10-09)",
	"sodipodi:docname": "logo.svg",
	"inkscape:export-filename": "logo.png",
	"inkscape:export-xdpi": 151.88779,
	"inkscape:export-ydpi": 151.88779,
	"xmlns:inkscape": "http://www.inkscape.org/namespaces/inkscape",
	"xmlns:sodipodi": "http://sodipodi.sourceforge.net/DTD/sodipodi-0.dtd",
	xmlns: "http://www.w3.org/2000/svg",
	"xmlns:svg": "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("sodipodi:namedview", {
			id: "namedview1",
			pagecolor: "#ffffff",
			bordercolor: "#000000",
			borderopacity: .25,
			"inkscape:showpageshadow": 2,
			"inkscape:pageopacity": 0,
			"inkscape:pagecheckerboard": 0,
			"inkscape:deskcolor": "#d1d1d1",
			"inkscape:document-units": "mm",
			showguides: "true",
			"inkscape:zoom": 2,
			"inkscape:cx": 16,
			"inkscape:cy": 139,
			"inkscape:window-width": 2560,
			"inkscape:window-height": 1011,
			"inkscape:window-x": 0,
			"inkscape:window-y": 0,
			"inkscape:window-maximized": 1,
			"inkscape:current-layer": "layer1"
		}),
		/* @__PURE__ */ _jsx("defs", { id: "defs1" }),
		/* @__PURE__ */ _jsxs("g", {
			"inkscape:label": "Layer 1",
			"inkscape:groupmode": "layer",
			id: "layer1",
			transform: "translate(-84.181425,-133.18361)",
			children: [
				/* @__PURE__ */ _jsx("path", {
					id: "path1",
					style: {
						fill: "#0074bd",
						fillOpacity: 1,
						stroke: "none",
						strokeWidth: .272673,
						strokeDasharray: "none",
						strokeOpacity: .993301
					},
					d: "m 109.37569,158.5949 c -0.0371,0 -0.0728,0.003 -0.10989,0.003 v 10.81327 a 5.235315,5.235315 0 0 1 0.10989,-0.0109 5.235315,5.235315 0 0 1 5.23612,5.23613 5.235315,5.235315 0 0 1 -2.0488,4.13421 v 8.19518 c 0,1.7721 -1.42649,3.19861 -3.1986,3.19861 -0.0333,0 -0.0654,-0.005 -0.0987,-0.005 v 10.83301 c 0.0371,5e-5 0.0726,0.003 0.10989,0.003 14.49905,0 24.97444,-4.87255 24.97444,-4.87255 v -16.3284 -16.32835 c 0,0 -10.47539,-4.87255 -24.97444,-4.87255 z"
				}),
				/* @__PURE__ */ _jsx("path", {
					id: "circle5",
					style: {
						fill: "#143761",
						fillOpacity: 1,
						stroke: "none",
						strokeWidth: .272672,
						strokeDasharray: "none",
						strokeOpacity: .993301
					},
					d: "m 109.26578,133.18361 a 20.723122,20.723122 0 0 0 -20.72186,20.7247 v 7.92742 c 1.985695,-0.64215 4.588836,-1.36189 7.665369,-1.96423 v -5.96319 a 13.055568,13.055568 0 0 1 13.056491,-13.05649 13.055568,13.055568 0 0 1 13.05649,13.05649 v 5.96319 c 3.07653,0.60234 5.67968,1.32208 7.66536,1.96423 v -7.92742 a 20.723122,20.723122 0 0 0 -20.72185,-20.7247 z"
				}),
				/* @__PURE__ */ _jsx("path", {
					id: "path3",
					style: {
						fill: "#018bcc",
						fillOpacity: 1,
						stroke: "none",
						strokeWidth: .272673,
						strokeDasharray: "none",
						strokeOpacity: .993301
					},
					d: "m 109.15587,158.5949 c -14.499054,0 -24.974445,4.87255 -24.974445,4.87255 v 16.32835 16.3284 c 0,0 10.475391,4.87256 24.974445,4.87256 0.0371,0 0.0728,-0.003 0.10989,-0.003 v -10.83301 c -1.72551,-0.0545 -3.09997,-1.45427 -3.09997,-3.19294 v -8.2093 a 5.235315,5.235315 0 0 1 -2.02625,-4.12009 5.235315,5.235315 0 0 1 5.12622,-5.22768 v -10.81327 c -0.0371,-5e-5 -0.0728,-0.003 -0.10989,-0.003 z"
				})
			]
		})
	]
});
export default SvgAuthyIcon;
